<template>
  <div class="pub_box">
    <h5 class="p_h5">{{ title }}</h5>
    <p v-html="serviceConfig" class="p_txt"></p>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
import { getSystemType } from "api/public";
export default {
  data() {
    return {
      title: "隐私政策",
      serviceConfig: ""
    };
  },
  created() {
    getSystemType("privacy_agreement_config").then(d => {
      this.serviceConfig = d.privacy_agreement_textarea;
    });
  },
  components: {
    Tab
  }
};
</script>

<style scoped lang="scss">
.pub_box {
  padding-top: 100px;
}
.p_h5 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.p_txt {
  padding: 15px 30px 50px;
  font-size: 28px;
  line-height: 40px;
  color: #111;
}
</style>



// WEBPACK FOOTER //
// src/pages/public/publicNote.vue